import { Component, ViewChild, ElementRef, ɵConsole, WritableSignal, signal, computed, Signal } from "@angular/core"; import { Location } from "@angular/common";
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CleValeur, CleValeurNumerique } from '../entites/cleValeur';
import { EntreeCommande } from '../entites/entree-commande';
import { ItemMin } from '../entites/item-min';
import { Statut } from '../entites/statut';
import { DonneesBaseService } from '../services/donnees-base-service';
import { BaseComponent } from '../base/base-component';
import { ItemService } from '../services/item-service';
import { BlockUIModule } from 'primeng/blockui';
import { FournisseurService } from '../services/fournisseur-service';
import { Fournisseur } from '../entites/fournisseur';
import { EmployeEntite } from '../entites/employe';
import { ItemCommandeEntite } from '../entites/item-commande';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table/table';
import { ProfilService } from '../services/profil-service';
import { ActivatedRoute, Router } from '@angular/router';
import { RequisitionService } from '../services/requisition-service';
import { AppMainComponent } from '../app.main.component';
import { CategorieEntite } from '../entites/categorie';
import { HttpEvent, HttpEventType } from "@angular/common/http";
import { SousCategorieEntite } from "../entites/sousCategorie";
import { MultiSelect } from "primeng/multiselect";

export interface ParametresSelectionItemSimple {
    choixCategorieDisponible: boolean;
    categorieIds?: number[];
}

export interface ResultatSelectionItemSimple {
    item?: ItemMin;
}

@Component({
    selector: 'app-selection-item-simple',
    templateUrl: './selection-item-simple.component.html',
    host: {
        '(document:keydown)': 'handleKeyboardEvents($event)'
    }
})
export class SelectionItemSimpleComponent extends BaseComponent {


    //Général

    donnees: ParametresSelectionItemSimple;

    categories: CategorieEntite[];
    statuts: Statut[];
    selectionCategorie: CategorieEntite[] = [];

    submitted: boolean;

    itemsComplets: ItemMin[];
    items: ItemMin[];
    selectionItem: ItemMin = { itemId: 0 };

    loadingEvent: WritableSignal<HttpEvent<any>> = signal(null);
    loadingError: WritableSignal<string> = signal(null);


    @ViewChild('rechercheItem') inputRechercheItem;
    @ViewChild('dt') tableItems: Table;
    @ViewChild('champFiltreCategorie') filtreCategorie: MultiSelect;

    constructor(
        profilService: ProfilService,
        route: ActivatedRoute,
        routerService: Router,
        appMain: AppMainComponent, location: Location,
        public itemService: ItemService,
        public requisitionService: RequisitionService,
        public fournisseurService: FournisseurService,
        public messageService: MessageService,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public sdb: DonneesBaseService) {
        super(sdb, profilService, route, routerService, appMain);
    }



    ngOnInit() {

        this.donnees = this.config.data;

        this.categories = this.sdb.Categories().filter(x => {
            if (this.donnees.categorieIds) {
                return this.donnees.categorieIds.includes(x.categorieId);
            }
            return true;
        });

        this.statuts = this.sdb.Statuts();

        this.colonnesDisponibles = [
            { champ: 'categorie', entete: 'Catégorie', afficheParDefaut: true },
            { champ: 'sousCategorie', entete: 'Sous-catégorie', afficheParDefaut: true },
            { champ: 'marque', entete: 'Marque', afficheParDefaut: false },
            { champ: 'modele', entete: 'Modèle', afficheParDefaut: false }
        ];

        this.colonnesSelectionnees = this.colonnesDisponibles.filter(x => x.afficheParDefaut);

        this.itemService.ObtenirItems(null).subscribe({
            next: (x) => {
                if (x.type == HttpEventType.Response) {
                    this.itemsComplets = x.body.value();
                    this.items = x.body.value();
                    this.CompleterChargement();

                    this.surChangementCategorie();
                }
                this.loadingEvent.set(x);
            },
            error: (error) => {
                this.loadingError.set(error.error);
            }

        });

    }

    handleKeyboardEvents(event: KeyboardEvent) {
        //TODO: mettre la touche raccoruci dans l'entite et générliser
        //TODO : valider si l'option est disponible ...

        if ((this.categories.map(cat => cat.nom.normalize("NFD").charAt(0)).includes(event.key) || event.key == 't') && event.altKey) {
            // Get the first letter of each categorie and remove accents
            const categorie = this.categories.find(cat => cat.nom.normalize("NFD").charAt(0) == event.key);

            if (event.altKey) {
                this.selectionCategorie = categorie ? [categorie] : [];
                this.surChangementCategorie();
            }
        }
    }

    surChangementCategorie() {
        this.filtreCategorie.writeValue(this.selectionCategorie.map(x => x.categorieId));
    }

    surEntreeRecherche() {
        if (this.tableItems.filteredValue != undefined &&
            this.tableItems.filteredValue.length == 1) {
            this.surSelectionItemInventaire(this.tableItems.filteredValue[0]);
        }
    }

    annuler() {
        this.ref.close(null);
    }

    surSelectionItemInventaire(item: ItemMin) {
        this.ref.close({
            item: item
        });
    }
}